module.exports = __webpack_public_path__ + "public/images/fitness.5b07202ce84e54244a0c2ee61ec821c4.png";